export function numberFormat(
  amount: number,
  locales = 'en-US',
  minimumDigits = 0,
  maximumDigits = 0
) {
  return `${(amount || 0).toLocaleString(locales, {
    minimumFractionDigits: minimumDigits,
    maximumFractionDigits: maximumDigits
  })}`;
}
